import { Box, Typography, Grid, IconButton, Button, Tooltip } from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import {
  columnTextField,
  columnCNPJCPFField,
  columnDateHourField,
} from "utils/tables-utils";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";

function StatusChip({ ativo, labelAtivo, labelInativo }) {
  const estilo = ativo
    ? {
        bg: themeColorsDesingSystem.green.backgroundActive,
        color: themeColorsDesingSystem.green.main,
      }
    : {
        bg: "#f5f5f5",
        color: themeColorsDesingSystem.gray?.main || "#616161",
      };

  return (
    <Box
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.25rem",
        padding: "0.25rem 0.5rem",
        borderRadius: "0.25rem",
        backgroundColor: estilo.bg,
        color: estilo.color,
      }}
    >
      {ativo ? <CheckCircleIcon fontSize="small" /> : <BlockIcon fontSize="small" />}
      {ativo ? labelAtivo : labelInativo}
    </Box>
  );
}

export default function TableSellers({
  data,
  loading,
  onResearch,
  onAddSeller,
  onEdit,
  onInativarReativar,
}) {

  const columnModel = [
    columnTextField({
      dataField: "SellerName",
      text: "Loja",
      align: "center",
      formatter: (_, row) => row.SellerName || "-",
    }),
    columnCNPJCPFField({
      dataField: "Cnpj",
      text: "CNPJ",
    }),
    columnTextField({
      dataField: "IdMarca",
      text: "Marca",
      align: "center",
      formatter: (_, row) => row.IdMarca ?? "-",
    }),
    columnTextField({
      dataField: "IdSeta",
      text: "Seta",
      align: "center",
      formatter: (_, row) => row.IdSeta || "-",
    }),
    columnTextField({
      dataField: "IdKarsten",
      text: "Karsten",
      align: "center",
      formatter: (_, row) => row.IdKarsten ?? "-",
    }),
    columnDateHourField({
      dataField: "CreatedAt",
      text: "Criado em",
    }),
    columnTextField({
      dataField: "PiNeomodePipelineAtivo",
      text: "Pipeline Neomode",
      align: "center",
      formatter: (_, row) => (
        <StatusChip
          ativo={!!row.PiNeomodePipelineAtivo}
          labelAtivo="Ativo"
          labelInativo="Inativo"
        />
      ),
    }),
    columnTextField({
      dataField: "IsActive",
      text: "Situação",
      align: "center",
      formatter: (_, row) => (
        <StatusChip ativo={!!row.IsActive} labelAtivo="Ativo" labelInativo="Inativo" />
      ),
    }),
    columnTextField({
      dataField: "Acoes",
      text: "Ações",
      align: "center",
      formatter: (_, row) => (
        <Box style={{ display: "flex", gap: 4, justifyContent: "center", flexWrap: "wrap" }}>
          <Tooltip title="Editar">
            <IconButton size="small" onClick={() => onEdit?.(row)} aria-label="Editar">
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={row.IsActive ? "Inativar" : "Reativar"}>
            <IconButton
              size="small"
              onClick={() => onInativarReativar?.(row)}
              aria-label={row.IsActive ? "Inativar" : "Reativar"}
            >
              {row.IsActive ? (
                <BlockIcon fontSize="small" />
              ) : (
                <CheckCircleIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      ),
    }),
  ];

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando sellers..." />
      ) : data.length > 0 ? (
        <ToolkitTable
          keyField="Id"
          dataTable={data}
          columnModel={columnModel}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          CustomHeader={() => (
            <Grid
              container
              justify="space-between"
              spacing={2}
              style={{ padding: "0 20px 20px 20px" }}
            >
              <Grid item>
                <Grid container spacing={2} alignItems="center">
                  <Typography>Sellers</Typography>
                  {onResearch && (
                    <Tooltip title="Atualizar">
                      <IconButton size="small" onClick={onResearch} aria-label="Atualizar">
                        <RefreshIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Grid>
              </Grid>
              <Button variant="contained" disabled={loading} onClick={onAddSeller}>
                <AddIcon /> Novo Seller
              </Button>
            </Grid>
          )}
          pagination={{
            options: [25, 50, 100],
            defaultOption: 25,
            showTotal: true,
          }}
        />
      ) : (
        <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
          <Button color="default" variant="contained" onClick={onAddSeller}>
            <AddIcon /> Novo Seller
          </Button>
        </Box>
      )}
    </div>
  );
}
